export const findMilanInDB = (milanStores, storeObj) => {
  const state = milanStores.find(state => state.name === storeObj.state.name)
  const metro = state.metros.find(metro => metro.pathname === storeObj.metro.pathname)
  const store = metro.stores.find(store => store.salesforceValue === storeObj.name)
  return { ...store, metro: { ...storeObj.metro }, state: { ...storeObj.state } }
}
